import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthProvider, getBaseUrl } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import breakpoints from "@cloudpremise/portal_core/src/themes/mui/assets/theme/base/breakpoints";

//Tabs
import ForgeTab from "./PluginTabs/Forge";
import HermesTab from "./PluginTabs/Hermes";
import IrisTab from "./PluginTabs/Iris";
import ProteusTab from "./PluginTabs/Proteus";
import ChronosTab from "./PluginTabs/Chronos";
import OrionTab from "./PluginTabs/Orion";
import EosTab from "./PluginTabs/Eos";

import Navbar from "../components/Navbar";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import "../styles/plugins.scss";

const Plugins = (props) => {
    const [ authorized, authType, token ] = useAuthProvider();
    const [ controller ] = useMaterialUIController();
    const { config, user } = controller;
    const basename = getBaseUrl();
    const routeParams = useParams();
    let currentTab = "forge";
    if(typeof(routeParams) === "object" && routeParams.hasOwnProperty("tab")){
        currentTab = routeParams.tab;
    }
    const defaultState = {
        search: "",
        tabs: [
            {
                name: "forge",
                label: "Forge"
            },
            {
                name: "hermes",
                label: "Hermes"
            },
            {
                name: "iris",
                label: "Iris"
            },
            {
                name: "proteus",
                label: "Proteus"
            },
            {
                name: "chronos",
                label: "Chronos"
            },
            {
                name: "orion",
                label: "Orion"
            },
            {
                name: "eos",
                label: "Eos"
            }
        ],
        tabsOrientation: "horizontal",
        currentTab: currentTab,
        loading: false,
        errorMessage: null
    };

    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);
    const navigate = useNavigate();
    React.useEffect(() => {
        if(!authorized){
            return navigate("/landing", { replace: true });
        }
    });

    React.useEffect(() => {
        // A function that sets the orientation state of the tabs.
        function handleTabsOrientation() {
          return window.innerWidth < breakpoints.values.sm
            ? setState({tabsOrientation: "vertical"})
            : setState({tabsOrientation: "horizontal"});
        }
    
        /** 
         The event listener that's calling the handleTabsOrientation function when resizing the window.
        */
        window.addEventListener("resize", handleTabsOrientation);
    
        // Call the handleTabsOrientation function to set the state with the initial value.
        handleTabsOrientation();
    
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleTabsOrientation);
    }, [state.tabsOrientation]);

    function onTabChange(event, tab){
        setState({
            currentTab: tab
        });
        window.history.replaceState(null, document.title, basename+"/admin/plugins/"+tab+window.location.search);
    }
    function renderTab(tab){
        return (
            <Tab
                label={tab.label}
                value={tab.name}
                key={tab.name}
            />
        )
    }
    function renderTabs(){
        return (
            <Tabs
                orientation={state.tabsOrientation}
                value={state.currentTab}
                onChange={onTabChange}
            >
                {
                    state.tabs.map((tab) => {
                        return renderTab(tab)
                    })
                }
            </Tabs>
        )
    }
    function renderTabContents(){
        let tabContent = null;
        switch(state.currentTab){
            case 'forge':
                tabContent = <ForgeTab />;
                break;
            case 'hermes':
                tabContent = <HermesTab />;
                break;
            case 'iris':
                tabContent = <IrisTab />;
                break;
            case 'proteus':
                tabContent = <ProteusTab />;
                break;
            case 'chronos':
                tabContent = <ChronosTab />;
                break;
            case 'orion':
                tabContent = <OrionTab />;
                break;
            case 'eos':
                tabContent = <EosTab />;
                break;
            default:
                break;
        }
        return tabContent;
    }
    if(!authorized || !user.superAdmin){
        return null;
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={config.hideLayout ? 0 : 3}>
                <Navbar />
                <MDBox mb={2}>
                    <MDTypography variant="h3">Core Plugins</MDTypography>
                </MDBox>
                <MDBox>
                    {renderTabs()}
                </MDBox>
                <MDBox mt={2} className={"tab-"+state.currentTab}>
                    {renderTabContents()}
                </MDBox>
            </MDBox>
        </DashboardLayout>
    )
}

export default Plugins;